import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/static/post/podcast.svg");
;
import(/* webpackMode: "eager" */ "/app/public/static/post/video.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleBanners/BannersPostSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleBanners/BannersPostTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleElements/ArticleContentVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleElements/ArticleGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleElements/ArticlePaidBlockade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleInfiniteScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleShareBar/ArticleShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/ArticleSuggestions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/atoms/ArticleScrollObserver.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/[id]/components/DraftModeBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(default)/[id]/components/styles/article.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Analytics/Facebook/FBPixelScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Analytics/Google/GAScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Article/atoms/badges/PremiumBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Article/Comments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CopyListener/CopyListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FormBuilder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/FreemiumOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/LoggedInOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/NotLoggedInOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/PremiumOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/SpeechSynthesis/SpeechSynthesisControler.tsx");
